import { useEffect } from 'react';

const useTitle = title => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title + ' - панэль кіравання say.by - Мова прафесіі';
    return () => {
      document.title = prevTitle;
    };
  });
};

export default useTitle;
